import React from 'react'
import "./footer.css"
import {SiYourtraveldottv} from "react-icons/si";
import {FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa"


const Footer = () => {

  return (
    <div className='footer'>
      <div className="secContainer container grid">
        <div className="logoDiv">
          <div className="footerLogo">
            <a href="#" className="logo">
              <h1 className='flex'>
                <SiYourtraveldottv className="icon"/>
                Happy Safar
              </h1>
            </a>
          </div>
          <div className="socials flex">
            <FaFacebookF className="icon"/>
            <FaInstagram className="icon"/>
            <FaTwitter className="icon"/>
          </div>
        </div>
        <div className="footerLinks">
          <span className="linkTitle">
            Information
          </span>
          <li>
            <a href="#Home">Home</a>
          </li>
          <li>
            <a href="#Popular">Explore</a>
          </li>
          <li>
            <a href="#Offers">Travel</a>
          </li>
          <li>
            <a href="#Blog">Blog</a>
          </li>
        </div>
        <div className="footerLinks">
          <span className="linkTitle">
            Helpful Links
          </span>
          <li>
            <a href="#">Destination</a>
          </li>
          <li>
            <a href="#">Support</a>
          </li>
          <li>
            <a href="#">Terms & Conditions</a>
          </li>
          <li>
            <a href="#">Privacy</a>
          </li>
        </div>
        <div className="footerLinks">
          <span className="linkTitle">
            Contact Us
          </span>
          <span className="phone">+212638964606</span>
          <span className="email">kamalelmaddini@gmail.com</span>
          <span className='email'>© 2024 KAMAL – All rights reserved</span>
        </div>
      </div>
    </div>
  )
}

export default Footer